var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFicha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.1 24.2",
    style: {
      enableBackground: "new 0 0 20.1 24.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00095B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ficha_Tecnica",
    transform: "translate(-52.634 -16.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    className: "st0",
    d: "M71.2,16.1h-17c-0.8,0-1.5,0.7-1.5,1.5v21.2c0,0.8,0.7,1.5,1.5,1.5h17c0.8,0,1.5-0.7,1.5-1.5 c0,0,0,0,0,0V17.6C72.7,16.8,72,16.1,71.2,16.1z M53.9,17.6c0-0.1,0.1-0.2,0.2-0.2h17c0.1,0,0.2,0.1,0.2,0.2v0v21.2 c0,0.1-0.1,0.2-0.2,0.2h-17c-0.1,0-0.2-0.1-0.2-0.2V17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    className: "st0",
    d: "M57.9,35h9.5c0.2,0,0.4-0.1,0.5-0.3c0.3-0.4,0.3-0.9,0-1.3c-0.1-0.2-0.3-0.3-0.5-0.3h-9.5 c-0.5,0.1-0.8,0.7-0.7,1.2C57.3,34.7,57.6,34.9,57.9,35L57.9,35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    className: "st0",
    d: "M57.9,30.9h9.5c0.2,0,0.4-0.1,0.5-0.3c0.3-0.4,0.3-0.9,0-1.3c-0.1-0.2-0.3-0.3-0.5-0.3h-9.5 c-0.5,0.1-0.8,0.5-0.7,1c0,0.2,0.1,0.5,0.2,0.7C57.5,30.8,57.7,30.9,57.9,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    className: "st0",
    d: "M57.9,27.1h9.5c0.4-0.1,0.8-0.5,0.7-0.9c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.5-0.3h-9.5 c-0.4,0.1-0.8,0.5-0.7,0.9c0,0.2,0.1,0.5,0.2,0.7C57.5,27,57.7,27.1,57.9,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    className: "st0",
    d: "M57.9,23.2h9.5c0.4-0.1,0.8-0.5,0.7-0.9c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.5-0.3h-9.5 c-0.4,0.1-0.8,0.5-0.7,0.9c0,0.2,0.1,0.5,0.2,0.7C57.5,23.1,57.7,23.2,57.9,23.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFicha);
export default __webpack_public_path__ + "static/media/ficha.6a3ecd9be6615df1ddd5de5443615b2e.svg";
export { ForwardRef as ReactComponent };